import { DestroyRef, DOCUMENT, inject } from '@angular/core';

/**
 * Asks the browser to confirm leaving the page (reload, tab close, another site) while
 * `isUnsaved()` holds, for as long as the calling component lives. Navigation inside the app
 * never fires `beforeunload`, so it is not covered. Call it in an injection context.
 */
export function warnBeforeUnload(isUnsaved: () => boolean): void {
  const window = inject(DOCUMENT).defaultView;
  if (!window) return;

  const listener = (event: BeforeUnloadEvent): void => {
    if (isUnsaved()) event.preventDefault();
  };

  window.addEventListener('beforeunload', listener);
  inject(DestroyRef).onDestroy(() => window.removeEventListener('beforeunload', listener));
}
